module.exports = __webpack_public_path__ + "img/img-1.e8e35a58.png";